module.exports = __webpack_public_path__ + "static/media/gift_card.b89c6ec6.png";